import { table } from './_table';

export const groups = {
  namespaced: true,
  modules: {
    table
  }
};
